// 3rd party imports
import * as React from 'react';

// bernie
import { withLocalization, LocalizedText } from 'bernie-l10n';

// ui
import { UitkHeading, UitkText } from 'uitk-react-text';

// components
import { AffiliateCTA } from '../affiliate-cta';
import { LocalizedComponentProps } from '@shared-ui/localization-context';

export interface OutroProps extends LocalizedComponentProps {
  locale?: string;
}

@withLocalization
export class Outro extends React.Component<OutroProps> {
  public render() {
    return (
      <UitkText align="center">
        <UitkHeading tag="h2" size={2}>
          <UitkText inline={true}>
            <LocalizedText message="lp.home.outro.title1" />
          </UitkText>{' '}
          <UitkText inline={true}>
            <LocalizedText message="lp.home.outro.title" />
          </UitkText>
        </UitkHeading>
        <UitkText spacing="six">
          <UitkText inline={true} weight="bold">
            <LocalizedText message="lp.home.outro.description.text1" />
          </UitkText>{' '}
          <UitkText inline={true}>
            <LocalizedText message="lp.home.outro.description.text2" />
          </UitkText>
        </UitkText>
        <UitkText spacing="six">
          <AffiliateCTA locale={this.props.locale}/>
        </UitkText>
      </UitkText>
    );
  }
}
